import React from 'react';

import StepExpanded from 'iovisit-theme/components/Views/Itinerary/StepExpanded';

const ItineraryDayView = ({ content, location }) => {
  return (
    <div id="page-itinerary" className="ui container">
      <div className="day day-expanded">
        <StepExpanded showLeadImage={false} step={content} />
      </div>
    </div>
  );
};

export default ItineraryDayView;
